module.exports = __webpack_public_path__ + "img/ic_julio_share.1fcfb035.svg";